const initialState = {
  status: false
};

export default initialState;
